module.exports = __webpack_public_path__ + "static/media/u25_1.b60d576e.mp3";